import type { PropsWithChildren } from 'react';
import { TamaguiProvider } from 'tamagui';

import adultingTamaguiConfig from './config';
import { adultingDefaultTheme } from './themes';

export function AdultingTamaguiProvider({ children }: PropsWithChildren) {
  return (
    <TamaguiProvider config={adultingTamaguiConfig} defaultTheme={adultingDefaultTheme}>
      {children}
    </TamaguiProvider>
  );
}
